import React, { useMemo } from 'react';
import styles from './style.module.scss';
import { MdShoppingCart } from 'react-icons/md';
import { FaUser, FaRegCheckCircle } from 'react-icons/fa';
import { IoCardOutline } from 'react-icons/io5';

const LabelStepsCarrinho = ({
  step,
  onChangeStep,
  labelConta = true,
  labelCarrinho = true
}) => {
  const steps = [
    {
      id: 0,
      label: 'Carrinho',
      icon: MdShoppingCart,
      show: labelCarrinho,
      clickable: true
    },
    {
      id: 1,
      label: 'Minha conta',
      icon: FaUser,
      show: labelConta,
      clickable: step >= 1
    },
    {
      id: 2,
      label: 'Pagamento',
      icon: IoCardOutline,
      show: true,
      clickable: step >= 2
    },
    {
      id: 3,
      label: 'Conclusão',
      icon: FaRegCheckCircle,
      show: true,
      clickable: false
    }
  ];

  const visibleSteps = useMemo(() => steps.filter((stepItem) => stepItem.show), [labelCarrinho, labelConta, step]);
  const visibleCurrentStepIndex = Math.max(0, visibleSteps.findIndex((stepItem) => stepItem.id === step));

  const handleStepClick = (stepId, clickable) => {
    if (clickable) {
      onChangeStep(stepId);
    }
  };

  const getStepStatus = (stepId) => {
    if (stepId < step) return 'completed';
    if (stepId === step) return 'active';
    return 'pending';
  };

  return (
    <div className={styles.container}>
      <div className={styles.stepsWrapper}>
        {visibleSteps.map((stepItem, index) => {
          const Icon = stepItem.icon;
          const status = getStepStatus(stepItem.id);
          const isClickable = stepItem.clickable && stepItem.id <= step;

          return (
            <React.Fragment key={stepItem.id}>
              <div
                className={`
                  ${styles.stepItem}
                  ${styles[status]}
                  ${isClickable ? styles.clickable : styles.disabled}
                `}
                onClick={() => handleStepClick(stepItem.id, isClickable)}
                role='button'
                tabIndex={isClickable ? 0 : -1}
                aria-label={`${stepItem.label} - ${status === 'completed' ? 'Concluído' : status === 'active' ? 'Atual' : 'Pendente'}`}
                onKeyDown={(e) => {
                  if ((e.key === 'Enter' || e.key === ' ') && isClickable) {
                    e.preventDefault();
                    handleStepClick(stepItem.id, isClickable);
                  }
                }}
              >
                <div className={styles.stepIcon}>
                  {status === 'completed' ? (
                    <FaRegCheckCircle className={styles.checkIcon} />
                  ) : (
                    <Icon className={styles.icon} />
                  )}
                  <div className={styles.stepNumber}>{index + 1}</div>
                </div>

                <div className={styles.stepContent}>
                  <span className={styles.stepLabel}>{stepItem.label}</span>
                  <div className={styles.stepIndicator}>
                    <div className={styles.progressDot}></div>
                  </div>
                </div>
              </div>

              {index < visibleSteps.length - 1 && (
                <div className={`${styles.connector} ${index < visibleCurrentStepIndex ? styles.connectorCompleted : ''}`}>
                  <div className={styles.connectorLine}></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{
            width: `${(visibleCurrentStepIndex / Math.max(visibleSteps.length - 1, 1)) * 100}%`
          }}
        ></div>
      </div>

      <div className={styles.mobileIndicator}>
        <span className={styles.currentStep}>
          Passo {visibleCurrentStepIndex + 1} de {visibleSteps.length}
        </span>
        <span className={styles.currentStepLabel}>
          {visibleSteps[visibleCurrentStepIndex]?.label}
        </span>
      </div>
    </div>
  );
};

export default LabelStepsCarrinho;
